import React from 'react';

const TrustIndicators = () => {
    return (
        <>
            <section id="about" className="py-4 bg-dark text-white">
                <div className="container py-4">
                    <div className="row g-4 text-center">
                        <div className="col-md-3 col-6 border-end border-white border-opacity-10">
                            <h2 className="fw-bold text-primary mb-1">100%</h2>
                            <p className="small text-white-50 mb-0 tracking-wide text-uppercase">Certified Doctors</p>
                        </div>
                        <div className="col-md-3 col-6 border-end border-white border-opacity-10">
                            <h2 className="fw-bold text-primary mb-1">24/7</h2>
                            <p className="small text-white-50 mb-0 tracking-wide text-uppercase">Instant Support</p>
                        </div>
                        <div className="col-md-3 col-6 border-end border-white border-opacity-10">
                            <h2 className="fw-bold text-primary mb-1">50k+</h2>
                            <p className="small text-white-50 mb-0 tracking-wide text-uppercase">Happy Patients</p>
                        </div>
                        <div className="col-md-3 col-6">
                            <h2 className="fw-bold text-primary mb-1">4.9</h2>
                            <p className="small text-white-50 mb-0 tracking-wide text-uppercase">App Rating</p>
                        </div>
                    </div>
                </div>
            </section>

            <footer className="bg-white border-top py-5">
                <div className="container pt-4">
                    <div className="row g-5">
                        <div className="col-lg-4">
                            <h4 className="fw-bold mb-3 d-flex align-items-center text-dark">
                                <i className="bi bi-heart-pulse-fill me-2 text-primary"></i> FITNOVA
                            </h4>
                            <p className="text-secondary small">
                                FitNova builds the bridge between patients and healthcare providers, ensuring accessible, secure, and professional medical assistance for all.
                            </p>
                        </div>
                        <div className="col-lg-2 col-6">
                            <h6 className="fw-bold mb-3 text-dark">Company</h6>
                            <ul className="list-unstyled small space-y-2">
                                <li><a href="#" className="text-decoration-none text-secondary hover-primary">About Us</a></li>
                                <li><a href="#" className="text-decoration-none text-secondary hover-primary">Careers</a></li>
                                <li><a href="#" className="text-decoration-none text-secondary hover-primary">Press</a></li>
                            </ul>
                        </div>
                        <div className="col-lg-2 col-6">
                            <h6 className="fw-bold mb-3 text-dark">Support</h6>
                            <ul className="list-unstyled small space-y-2">
                                <li><a href="#" className="text-decoration-none text-secondary hover-primary">Help Center</a></li>
                                <li><a href="#" className="text-decoration-none text-secondary hover-primary">Terms of Service</a></li>
                                <li><a href="#" className="text-decoration-none text-secondary hover-primary">Privacy Policy</a></li>
                            </ul>
                        </div>
                        <div className="col-lg-4">
                            <h6 className="fw-bold mb-3 text-dark">Newsletter</h6>
                            <div className="input-group">
                                <input type="email" className="form-control bg-light border-0" placeholder="Your email address" />
                                <button className="btn btn-primary">Subscribe</button>
                            </div>
                        </div>
                    </div>
                    <div className="text-center mt-5 pt-4 border-top">
                        <p className="text-muted small mb-0">&copy; 2024 FitNova Healthcare. All rights reserved.</p>
                    </div>
                </div>
            </footer>
        </>
    );
};

export default TrustIndicators;
